/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { fetchTaskList, totalTaskCount } from '../../Components/action/common'
import TaskListDetails from './TaskListDetails'
import { useDispatch, useSelector } from 'react-redux'
import { setDateChange, setNoDateTaskList, setTotalCount } from '../../redux/slices/TaskSlice'
import { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import AllLoader from '../../Components/SkeletonLoading/AllLoader'
import { Accordion } from 'react-accessible-accordion'
import InfiniteScroll from 'react-infinite-scroll-component' 
import _ from 'lodash'

function NoDate() {
  const dispatch=useDispatch()

  // global state
  const { noDataTaskList} = useSelector(state=>state.task)
  const {theme} = useSelector(state=>state.theme)
  const [list,setList]=useState([])
  const currentTimes = moment().startOf('date')
  const [currentTime, setCurrentTime] = useState(new Date(currentTimes));
  const [isLoader,setIsLoader]=useState(true)
  const wrapperRef = useRef(null)

  const fetchAddTaskData = async () => {
    setIsLoader(true)
    try {
      let response = await fetchTaskList({"type": 4, "status": 0})
      const noDataTaskList = _.chunk(response?.data?.responseData, 15);
      const chunk = noDataTaskList.splice(0, 1);
      setList(noDataTaskList)
      dispatch(setNoDateTaskList(chunk?.[0] ?? []))
      setIsLoader(false)
    } catch ({ response }) {
      setIsLoader(false)
    }
  }

  const fetchTotalCount=async()=>{
    try {
      let response=await totalTaskCount({"date":currentTime.toISOString()})
      dispatch(setTotalCount(response?.data?.responseData))
    } catch ({response}) {
      
    }
  }

  useEffect(() => {
    dispatch(setDateChange(null))
    fetchAddTaskData()
    fetchTotalCount()
  }, [])

  // useEffect(() => {
  //   if(isLoader) return;

  //   const bound = wrapperRef.current.getBoundingClientRect()
  //   wrapperRef.current.style.height = window.innerHeight - bound.top + 'px'
  // }, [isLoader])

  const fetchMoreData = (noDataTaskList) => {
    const chunk = list.splice(0, 1);
    if(chunk.length > 0){
      setList(list)
      dispatch(setNoDateTaskList([...noDataTaskList, ...chunk[0]]))
    }else{
      setList([])
    }
  }

  return (
    <>
      {
        isLoader ? <AllLoader/> :  <>
        <div id="tasks-list-wrapper" ref={wrapperRef} className="overdue-form task-list-page rounded-t-[25px] bg-white dark:bg-transparent !h-[100vh]">
          <div className="task-list" >
            <div className="task-list-data">
              <div className="ul-task-list">
                <div className="task-list" css={{
                  '.infinite-scroll-component':{
                    overflowX: 'hidden !important'
                  }
                }}>
                  <InfiniteScroll
                    dataLength={noDataTaskList?.length ?? 0}
                    next={() => fetchMoreData(noDataTaskList)}
                    hasMore={list.length > 0}
                    loader={<AllLoader  />}
                    scrollableTarget="tasks-list-wrapper"
                  >
                  <Accordion preExpanded={['accitem0']}>
                    <TaskListDetails 
                    fetchAddTaskData={fetchAddTaskData}
                    noDataTaskLists={noDataTaskList}
                    currentPage="noDate"
                    fetchTotalCount={fetchTotalCount}
                    />
                  </Accordion>
                  </InfiniteScroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      }
   
  </>
  )
}

export default NoDate